/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loved_Tangy_Hare_AttendInputs */

const fr_loved_tangy_hare_attend = /** @type {(inputs: Loved_Tangy_Hare_AttendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carré`)
};

/**

* @param {Loved_Tangy_Hare_AttendInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const loved_tangy_hare_attend = /** @type {((inputs?: Loved_Tangy_Hare_AttendInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loved_Tangy_Hare_AttendInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_loved_tangy_hare_attend(inputs)
});